import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../theme/getTheme';
import { PALETTE } from '../CoinStoreModal/CoinStoreModal.constants';

export const shopSegmentedControlStyles = (theme: Theme) => StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignSelf: 'center',
    backgroundColor: PALETTE.surface,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: PALETTE.surfaceBorder,
    padding: 3,
    gap: 3,
    ...(Platform.OS === 'web'
      ? { boxShadow: `0 4px 0 ${PALETTE.dropShadow}, inset 0 1px 0 rgba(255,255,255,0.04)` }
      : { shadowColor: PALETTE.dropShadow, shadowOffset: { width: 0, height: 4 }, shadowOpacity: 1, shadowRadius: 0, elevation: 4 }),
  },
  segment: {
    paddingVertical: 8,
    paddingHorizontal: 22,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 90,
  },
  segmentInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  segmentActive: {
    backgroundColor: theme.primary,
    // iOS/web get the hard-offset 3D shadow. Android is intentionally left flat: its
    // elevation API ignores shadowOffset/shadowRadius and draws a soft shadow ring that —
    // with only 3px of padding inside the dark container — renders as a square framing the
    // rounded pill ("square inside square"). The bright fill already signals the active tab.
    ...(Platform.OS === 'web'
      ? { boxShadow: `0 3px 0 ${theme.primaryDark ?? '#6D28D9'}, inset 0 1px 0 rgba(255,255,255,0.25)` }
      : Platform.OS === 'ios'
        ? { shadowColor: theme.primaryDark ?? '#6D28D9', shadowOffset: { width: 0, height: 3 }, shadowOpacity: 1, shadowRadius: 0 }
        : {}),
  },
  segmentInactive: { backgroundColor: 'transparent' },
  segmentPressed: { transform: [{ translateY: 1 }], opacity: 0.85 },
  segmentHoverWeb: { opacity: 0.88 },
  tabIcon: { width: 16, height: 16 },
  tabIconCrown: { width: 18, height: 18 },
  label: {
    fontSize: 14,
    fontWeight: '900',
    letterSpacing: 0.2,
  },
  labelActive: { color: '#111827' },
  labelInactive: { color: 'rgba(255,255,255,0.55)' },
});
